import React, { useState, useEffect, Fragment } from "react";
import { HashLink as Link } from "react-router-hash-link";
import { useHistory } from "react-router-dom";
import Icon from "@identitybuilding/idb-react-iconlib";
import { useDispatch, useSelector } from "react-redux";
import { updateLang } from "../actions";
import auth from "../store/auth";

const Nav = (props) => {
  const sections = document.querySelectorAll("section");
  const navLi = document.querySelectorAll("nav .mainNav ul .PageNav li");
  const dispatch = useDispatch();
  const history = useHistory();
  const [color, setColor] = useState("");

  const { data, lang, modules, translate } = useSelector((state) => state.AdminReducer);

  useEffect(() => {


    if (window.location.href.includes('/recepten')) {
      let li = document.getElementsByClassName('recepten')[0]
      li.classList.add('active')
    }
    if (window.location.href.includes('/fotoalbum')) {
      let li = document.getElementsByClassName('photo_album')[0]
      li.classList.add('active')
    }
    window.addEventListener("scroll", (e) => handleScroll(e));
    return window.removeEventListener("scroll", (e) => handleScroll(e));
  }, [modules]);

  window.onscroll = () => {
    if (!window.location.href.includes('recepten') && !window.location.href.includes('fotoalbum')) {
      var current = "";

      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        // if (window.pageYOffset < 639) {
        //   current = section.getAttribute("id");
        // }
        // 92 is the height of your navigations, if that changes you have to change this!
        // Made it double the height here
        if (window.pageYOffset >= sectionTop - 165) {
          current = section.getAttribute("id");
        }
      });

      navLi.forEach((li) => {
        li.classList.remove("active");
        if (li.classList.contains(current)) {
          li.classList.add("active");
        }
      });
    }
  };

  const handleScroll = () => {
    let scrollTop = document.documentElement.scrollTop;
    setColor(scrollTop > 0 ? "var(--grey-90)" : null);
  };

  const langHandler = (e) => {
    dispatch(updateLang(e));
  };

  const logout = () => {
    auth.actions.logout();
    history.push("/");
    auth.state.admin = undefined;
  };

  const langBlock = (
    <div className="dropdown">
      <button className="dropbtn">
        {lang === "nl" ? "Nederlands" : "Français"}
      </button>
      <div className="dropdown-content">
        <span onClick={() => window.location.href = window.location.href.replace('lang=fr', 'lang=nl')}>Nederlands</span>
        <span onClick={() => window.location.href = window.location.href.replace('lang=nl', 'lang=fr')}>Français</span>
      </div>
    </div>
  );

  const langBlock2 = (
    <div className="langBlock2">
      <a
        className={`${window.location.href.includes('lang=nl') ? 'active' : ''}`}
        href={window.location.href.replace('lang=fr', 'lang=nl')}
      >
        NL
      </a>
      <span>|</span>
      <a
        className={`${window.location.href.includes('lang=fr') ? 'active' : ''}`}
        href={window.location.href.replace('lang=nl', 'lang=fr')}
      >
        FR
      </a>
    </div>
  );


  return (
    <nav>
      {/* <div className="topNav">{langBlock}</div> */}
      <div
        className={[
          "mainNav",
          props.hover_animation,
          props.background ? "bgNav" : "tNav",
        ].join(" ")}
        style={{ backgroundColor: "white", color: "var(--gray-90)" }}
      >
        <div className="navLogo mobileLogo">
          <Link to={`/?lang=${lang}#Home`}>
            <img src={data.logos.length > 0 ? data.logos[0].logo : ""} />
          </Link>
        </div>
        <div className="mobileNav">
          <Icon name="MenuFill" />
        </div>

        <ul
          className="navItems"
          style={{ textAlign: props.position ? props.position : "right" }}
        >
          <div className="navLogo">

            <Link to={`/?lang=${lang}#Home`}>
            <img src={data.logos.length > 0 ? data.logos[0].logo : ""} />
            </Link>
          </div>

          <div className="PageNav">
            {(history.location.pathname === "/" || history.location.pathname === "/fotoalbum" || history.location.pathname === "/recepten") && (
              <Fragment>
                {modules.map(
                  (res, index) =>
                    res.active &&
                    res.name === "Home" && res.name !== "Footer" && (
                      <li className={res.alias} key={index}>
                        <Link
                          style={{ color: color }}
                          to={`/?lang=${lang}#${res.name.replace(/\s/g, "").replace(/\-/g, "")}`}
                        >
                          <Icon name="Home" />
                        </Link>
                      </li>
                    )
                )}
                {modules.map((res, index) =>
                  res.active && res.name !== "Home" && res.name !== "Footer" && res.new_page === false ? (
                    <li className={res.alias} key={index}>
                      <Link
                        style={{ color: color }}
                        to={`/?lang=${lang}#${res.name.replace(/\s/g, "").replace(/\-/g, "")}`}
                      >
                        {translate(res.title)}
                      </Link>
                    </li>
                  )
                    : res.active && res.name !== "Home" && res.name !== "Footer" &&
                    <li className={res.alias} key={index}>
                      <a style={{ color: color }} href={`/${res.slug}?lang=${lang}`}>
                        {translate(res.title)}
                      </a>
                    </li>
                )}
              </Fragment>
            )}
          </div>
          {langBlock2}
        </ul>
      </div>
    </nav>
  );
};

export default Nav;
